import { defineRecipe } from '@chakra-ui/react';

export const panelRecipe = defineRecipe({
  className: 'ac-panel',
  base: {
    width: '100%',
    minHeight: '100px',
    boxShadow: '10px 10px 15px 0px {colors.grey.dark.1/2}',
    backgroundColor: 'white',
    borderRadius: 'main',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: 'grey.light.3',

    padding: '35px 40px',

    overflow: 'hidden',
  },
  variants: {
    mode: {
      fixed: {
        borderRadius: 'main',
        borderWidth: '1px',
      },
      packed: {
        borderRadius: {
          base: '0px',
          sm: 'main',
        },
        borderWidth: {
          base: '0px',
          sm: '1px',
        },
        borderTopWidth: '1px',
        borderBottomWidth: '1px',
        padding: {
          base: '25px 20px',
          sm: '35px 40px',
        },
      },
    },
  },
  defaultVariants: {
    mode: 'fixed',
  },
});
